const initialState = {
    modals: []
};

export const CUSTOM_MODAL_OPEN = "CUSTOM_MODAL_OPEN";
export const CUSTOM_MODAL_CLOSE = "CUSTOM_MODAL_CLOSE";

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case CUSTOM_MODAL_OPEN:
            return {
                ...state,
                modals: state.modals.concat(action.obj)
            };
        case CUSTOM_MODAL_CLOSE:
            return {
                ...state,
                modals: state.modals.filter(item => item.id !== action.obj.id),
            };
        default:
            return state;
    }
}
